<a
  *transloco="let t; read: 'social-share-buttons'"
  id="trkFacebookShareButton"
  class="btn-share btn-share-facebook"
  href="javascript:void(0)"
  [attr.aria-label]="t('facebook_share')"
  (click)="share()">
  <accredible-icon [icon]="'facebook'"> </accredible-icon>
</a>
